/**
 * Root-Routen der Anwendung.
 *
 * - /chat: Chat-Feature (lazy-loaded, geschützt durch authGuard)
 * - /: Redirect auf /chat
 * - **: Catch-all-Redirect auf /chat
 */
import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'chat',
    loadChildren: () => import('./features/chat/chat.routes').then((m) => m.CHAT_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: '',
    redirectTo: '/chat',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/chat',
  },
];
